import React from 'react';
import { connect } from 'react-redux';

const ThemeEightFooter = ({ operator, pbServiceList }) => {
  console.log(pbServiceList.serviceList, '----------pbServiceList');
  return (
    operator && (
      <div className="themes-theme-eight-footer">
        <div
          style={{
            // color:
            //   operator &&
            //   operator.color_codes &&
            //   operator.color_codes.secondary_text_color &&
            //   operator.color_codes.secondary_text_color,
            background:
              operator &&
              operator.color_codes &&
              operator.color_codes.primary_color &&
              operator.color_codes.primary_color,
          }}
          className="footer"
        >
          <span className="bold-text">
            {operator.name ? operator.name : ''} {new Date().getFullYear()}
          </span>
          <span className="mx-2"> | Todos los derechos reservados © Powered by </span>
          <a
            href="https://kupos.cl"
            target="_blank"
            className="bold-text"
            style={{ color: 'white' }}
          >
            kupos.cl
          </a>
        </div>
      </div>
    )
  );
};

function mapStateToProps(state) {
  return {
    pbServiceList: state.pbServiceList,
    // home: state.home,
    // common: state.common,
  };
}

export default connect(mapStateToProps, {})(ThemeEightFooter);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeEight/common/ThemeEightFooter.js